import { Box, Grid, IconButton, Typography, useTheme } from "@mui/material";
import React, { FC, useEffect } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import { useActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";

import AnnouncementItem from "../../../components/AnnouncementItem";
import LinkRouter from "../../../components/LinkRouter";
import AnnouncementItemTablet from "../../../components/AnnouncementItem/AnnouncementItemTablet";

const AnnouncementsCarouselTablet = () => {
    const { palette } = useTheme();

    const { GetNovelties } = useActions();
    const { announcements } = useTypedSelector((store) => store.announcementUser);

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            await GetNovelties(false, "", "", 1, 10, null);
        } catch (ex) {
        }
    };

    return (
        <Grid item md={5} lg={12}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: "43px" }}>
                <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" sx={{ fontSize: "h3.fontSize" }}>
                    Анонси
                </Typography>
                <LinkRouter underline="none" color="text.secondary" to={"/announcements"}>
                    <Typography fontSize="20px" lineHeight="32px" fontFamily="Fixel Display, sans-serif" fontWeight="600">
                        Більше...
                    </Typography>
                </LinkRouter>
            </Box>
            <Box sx={{ height: "361px", position: "relative", mt: "16px" }}>
                <Swiper
                    modules={[Pagination, Navigation]}
                    pagination={{
                        type: "progressbar",
                        el: '.custom-pagination',
                    }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        disabledClass: "disabled-cursor"
                    }}
                    slidesPerView={2.5}
                    slidesPerGroup={1}
                    spaceBetween={12}
                    style={{ height: "317px", paddingLeft: "0px", paddingRight: "36px" }}
                >
                    {announcements.map((item, index) => {
                        return (
                            <SwiperSlide key={`swiper_${item.urlSlug}`} >
                                <AnnouncementItemTablet isProject={false} urlSlug={item.urlSlug} title={item.title} description={item.description} imagePreview={item.imagePreview} date={item.date} announcementTime={item.announcementTime} hashtags={item.hashtags} />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <Box sx={{ width: "100%", display: "flex", position: "absolute", left: "0px", bottom: "0px", height: "44px" }}>
                    <Box
                        className="custom-pagination"
                        sx={{
                            width: "639px !important",
                            height: "5px !important",
                            background: `#3C3C47 !important`,
                            borderRadius: "4px !important",
                            "& .swiper-pagination-progressbar-fill": {
                                background: `${palette.primary.main} !important`,
                                borderRadius: "4px !important",
                            },
                            mt: "20px",
                            ml: "16px"
                        }}
                    />
                    <Box className="swiper-button-prev" sx={{ right: "52px !important", left: "unset !important", top: "35% !important" }} />
                    <Box className="swiper-button-next" sx={{ right: "12px !important", top: "35% !important" }} />
                </Box>
            </Box>
        </Grid>
    );
};

export default AnnouncementsCarouselTablet;
